import Immutable                        from 'immutable';
import { QUOTE_SUCCESS, QUOTE_FAILURE } from 'pu-redux/actions/QuoteActions';

const quoteReducer = (state = Immutable.fromJS({}), action) => {
  const { quote } = action;
  switch (action.type) {
    case QUOTE_SUCCESS:
      return Immutable.fromJS(quote);

    case QUOTE_FAILURE:
      return Immutable.fromJS({});

    default:
      return state;
  }
};

export default quoteReducer;
